import api from '../../../services/api';
import type { Permission, Role } from '../types/auth.types';

const rbacPath = '/rbac';

interface UserRbac {
    id: string;
    roles: Role[];
    permissions: Permission[];
}

export const fetchUserRbac = async (): Promise<UserRbac> => {
    const response = await api.get<UserRbac>(`${rbacPath}/me`);
    return response.data;
};
